export const getRandomColor = () => {
  const colors = [
    '#2680eb',
    '#85d044',
    '#44b556',
    '#1b959a',
    '#9256d9',
    '#6767ec',
    '#d83790',
    '#c038cc',
    '#e68619',
    '#e34850',
    '#dfbf00',
  ];
  return colors[Math.floor(Math.random() * 11)];
};

export const WEEK = 7;
export const MONTH = 5;

export const selectValues = {
  viewOptions: [
    {
      id: '423ab563-1d41-472f-a8b1-890cfc6bc482',
      value: WEEK,
      name: 'Week',
    },
    {
      id: '9c91e773-ad47-478e-a20e-8464da77ff82',
      value: MONTH,
      name: 'Month',
    },
  ],
};

export const MOCKProjects = [
  // // WEEK
  // {
  //   ID: '60a3aa380028e571645ee42b48cac96a',
  //   name: 'Create Copy & Layout',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-07-30T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-27T17:00:00:000-0600',
  //   progressStatus: 'LT',
  //   project: {
  //     ID: '60a3aa380028e5597d9760c75dcbb2e3',
  //     name: 'Banner Template - Project',
  //     objCode: 'PROJ',
  //     percentComplete: 33.76,
  //     plannedCompletionDate: '2021-06-01T13:00:00:000-0600',
  //     plannedStartDate: '2021-05-18T09:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: '60a3aa380028e575e8e1df8e42797e1d',
  //   name: 'Production',
  //   objCode: 'TASK',
  //   percentComplete: 20,
  //   plannedCompletionDate: '2021-05-26T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-24T17:00:00:000-0600',
  //   progressStatus: 'ON',
  //   project: {
  //     ID: '60a3aa380028e5597d9760c75dcbb2e3',
  //     name: 'Banner Template - Project',
  //     objCode: 'PROJ',
  //     percentComplete: 33.76,
  //     plannedCompletionDate: '2021-06-01T13:00:00:000-0600',
  //     plannedStartDate: '2021-05-18T09:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc20dadc634e0539260720a06e3',
  //   name: 'Telecom and Internet in Booth',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-05-29T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-26T17:00:00:000-0600',
  //   progressStatus: 'ON',
  //   project: {
  //     ID: 'adca2fc163e6c634e0539260720a06e3',
  //     name: 'Update Web For Apple Pay Benefits',
  //     objCode: 'PROJ',
  //     percentComplete: 38.72,
  //     plannedCompletionDate: '2020-09-16T13:00:00:000-0600',
  //     plannedStartDate: '2020-07-13T09:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc20327c634e0539260720a06e3',
  //   name: 'Ship',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-06-01T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-26T17:00:00:000-0600',
  //   progressStatus: 'LT',
  //   project: {
  //     ID: 'adca2fc16352c634e0539260720a06e3',
  //     name: 'Ad for First Time Home Buyer Promotion',
  //     objCode: 'PROJ',
  //     percentComplete: 100,
  //     plannedCompletionDate: '2020-08-15T17:00:00:000-0600',
  //     plannedStartDate: '2020-07-05T00:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc20caac634e0539260720a06e3',
  //   name: 'Registration',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-06-02T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-30T17:00:00:000-0600',
  //   progressStatus: 'ON',
  //   project: {
  //     ID: 'adca2fc16366c634e0539260720a06e3',
  //     name: 'Summer Float',
  //     objCode: 'PROJ',
  //     percentComplete: 100,
  //     plannedCompletionDate: '2020-08-24T13:00:00:000-0600',
  //     plannedStartDate: '2020-06-21T14:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc1e52cc634e0539260720a06e3',
  //   name: 'Go/No Go Email Review',
  //   objCode: 'TASK',
  //   percentComplete: 10,
  //   plannedCompletionDate: '2021-06-30T17:00:00:000-0600',
  //   plannedStartDate: '2021-06-30T17:00:00:000-0600',
  //   progressStatus: 'LT',
  //   project: {
  //     ID: 'adca2fc1632ec634e0539260720a06e3',
  //     name: 'Mobile App Awareness Campaign',
  //     objCode: 'PROJ',
  //     percentComplete: 37.17,
  //     plannedCompletionDate: '2020-11-03T17:00:00:000-0700',
  //     plannedStartDate: '2020-08-04T02:00:00:000-0600',
  //   },
  // },
  // MONTH
  // {
  //   ID: '60a3aa380028e571645ee42b48cac96a',
  //   name: 'Create Copy & Layout',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-06-09T17:00:00:000-0600',
  //   plannedStartDate: '2021-04-03T17:00:00:000-0600',
  //   progressStatus: 'LT',
  //   project: {
  //     ID: '60a3aa380028e5597d9760c75dcbb2e3',
  //     name: 'Banner Template - Project',
  //     objCode: 'PROJ',
  //     percentComplete: 33.76,
  //     plannedCompletionDate: '2021-06-01T13:00:00:000-0600',
  //     plannedStartDate: '2021-05-18T09:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: '60a3aa380028e575e8e1df8e42797e1d',
  //   name: 'Production',
  //   objCode: 'TASK',
  //   percentComplete: 20,
  //   plannedCompletionDate: '2021-05-26T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-24T17:00:00:000-0600',
  //   progressStatus: 'ON',
  //   project: {
  //     ID: '60a3aa380028e5597d9760c75dcbb2e3',
  //     name: 'Banner Template - Project',
  //     objCode: 'PROJ',
  //     percentComplete: 33.76,
  //     plannedCompletionDate: '2021-06-01T13:00:00:000-0600',
  //     plannedStartDate: '2021-05-18T09:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc20dadc634e0539260720a06e3',
  //   name: 'Telecom and Internet in Booth',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-05-29T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-26T17:00:00:000-0600',
  //   progressStatus: 'ON',
  //   project: {
  //     ID: 'adca2fc163e6c634e0539260720a06e3',
  //     name: 'Update Web For Apple Pay Benefits',
  //     objCode: 'PROJ',
  //     percentComplete: 38.72,
  //     plannedCompletionDate: '2020-09-16T13:00:00:000-0600',
  //     plannedStartDate: '2020-07-13T09:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc20327c634e0539260720a06e3',
  //   name: 'Ship',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-06-01T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-26T17:00:00:000-0600',
  //   progressStatus: 'LT',
  //   project: {
  //     ID: 'adca2fc16352c634e0539260720a06e3',
  //     name: 'Ad for First Time Home Buyer Promotion',
  //     objCode: 'PROJ',
  //     percentComplete: 100,
  //     plannedCompletionDate: '2020-08-15T17:00:00:000-0600',
  //     plannedStartDate: '2020-07-05T00:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc20caac634e0539260720a06e3',
  //   name: 'Registration',
  //   objCode: 'TASK',
  //   percentComplete: 100,
  //   plannedCompletionDate: '2021-06-02T17:00:00:000-0600',
  //   plannedStartDate: '2021-05-30T17:00:00:000-0600',
  //   progressStatus: 'ON',
  //   project: {
  //     ID: 'adca2fc16366c634e0539260720a06e3',
  //     name: 'Summer Float',
  //     objCode: 'PROJ',
  //     percentComplete: 100,
  //     plannedCompletionDate: '2020-08-24T13:00:00:000-0600',
  //     plannedStartDate: '2020-06-21T14:00:00:000-0600',
  //   },
  // },
  // {
  //   ID: 'adca2fc1e52cc634e0539260720a06e3',
  //   name: 'Go/No Go Email Review',
  //   objCode: 'TASK',
  //   percentComplete: 10,
  //   plannedCompletionDate: '2021-06-06T17:00:00:000-0600',
  //   plannedStartDate: '2021-06-30T17:00:00:000-0600',
  //   progressStatus: 'LT',
  //   project: {
  //     ID: 'adca2fc1632ec634e0539260720a06e3',
  //     name: 'Mobile App Awareness Campaign',
  //     objCode: 'PROJ',
  //     percentComplete: 37.17,
  //     plannedCompletionDate: '2020-11-03T17:00:00:000-0700',
  //     plannedStartDate: '2020-08-04T02:00:00:000-0600',
  //   },
  // },
];
